import { useMutation, useQueryClient } from '@tanstack/react-query';

import { parseErrors, Toast } from 'helpers';
import { postTicket } from 'queries';
import { type JsonDataItem } from 'types';

function useCreateTicket() {
  const client = useQueryClient();

  const { mutate, isLoading } = useMutation(postTicket, {
    onSuccess: (_, { customerId, jobId, technicianId }) => {
      customerId && client.refetchQueries(['get-tickets', 'customer', customerId]);

      // NOTE: This does nothing until BMS-842 is completed
      jobId && client.refetchQueries(['get-tickets', 'job', jobId]);

      technicianId && client.refetchQueries(['get-tickets', 'technician', technicianId]);

      Toast.show({ message: 'New ticket has been created.', type: Toast.Type.Success });
    },
    onError: (data: JsonDataItem) => {
      Toast.show({ description: parseErrors(data).join(', '), type: Toast.Type.Error });
    },
  });

  return { createTicket: mutate, isLoading };
}

export { useCreateTicket };
